<template>
  <div class="center">
    <h1 class="centered">{{ $t("form.unsubscribe_title") }}</h1>
    <p class="p-centered">{{ $t("form.unsubscribe_text") }}</p>
  </div>
</template>

<script>
export default {
  mounted() {
    this.$store.commit("form/removeAll");
    this.$store.commit("loader/activeLoader", false);
  },
};
</script>

<style lang="scss" scoped>
h1 {
  font-family: raleway, sans-serif;
  font-weight: 700;
  font-style: normal;
  color: black;
  font-size: 52px;
}

p {
  font-family: raleway, sans-serif;
  font-weight: 400;
  font-style: normal;
  font-size: 16px;
  color: black;
}

.centered {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.p-centered {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  text-align: center;
}

.center {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
</style>
